import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "../asset/style/Card.css";

function Card({ header, content, icon }) {
  return (
    <div className="card">
      <div className="card_icon">
        <FontAwesomeIcon icon={icon} />
      </div>
      <div>
        <h2>{header}</h2>
        <p>{content}</p>
      </div>
    </div>
  );
}

export default Card;
